module.exports = __webpack_public_path__ + "img/texture-home-gap.39bd3c5e.png";